import React from "react";
import CapsaTitle from "../CapsaTitle/block.js"
import BackgroundOpenGrid from "../shared/BackgroundOpenGrid";

export default class MosaicFacet extends React.Component {

	render() {
		return <a href={this.props.url}>
			<div className={"mosaic-facet "+this.props.height}>
				<div className="background" style={this.props.image ? {backgroundImage:"url("+this.props.image+")"} : null} />
				<div className="content">
					<CapsaTitle title={this.props.title} text="white" bg="blue" position="left" />
					<p className="description" dangerouslySetInnerHTML={{__html: this.props.description}} />
					{this.props.showGrid &&
						<BackgroundOpenGrid width="51"
										height="93"
										top="10"
										left="10"
										color="grey" />
					}
				</div>
			</div>
		</a>
	}

}
